import { createAction, props } from '@ngrx/store';
import { AuthReducerInitialState } from '../reducers/auth.reducer';

const prefix = '[Auth]';

export const setAuthStateAction = createAction(
  `${prefix} set state`,
  props<Partial<AuthReducerInitialState>>(),
);
